module.exports = __webpack_public_path__ + "img/slider-1.5eab3e2f.png";